import React from "react";
import { ExternalLink, Phone, Mail } from "lucide-react";
import { BOOKING_URL, PHONE_TEL, PHONE_DISPLAY } from "./Header";

export function CtaBlock({
  variant = "dark",
  eyebrow = "Ready to book?",
  title = "Book direct and save.",
  body = "Skip the middleman fees. Every reservation on our booking page goes straight to the front desk.",
  compact = false,
  showEmail = true,
  className = "",
  testId,
}) {
  const isDark = variant === "dark";
  return (
    <section
      className={`${isDark ? "bg-forest-900 text-cream" : "bg-cream-100 text-forest-900"} ${compact ? "py-14 md:py-20" : "py-20 md:py-28"} ${className}`}
      data-testid={testId || "cta-block"}
    >
      <div className="container-app grid md:grid-cols-12 gap-8 md:gap-16 items-center">
        <div className="md:col-span-7">
          <p
            className={`eyebrow ${isDark ? "text-brass-300" : "text-brass"} mb-3`}
          >
            {eyebrow}
          </p>
          <h2 className="font-display font-light text-3xl md:text-5xl leading-[1.05] tracking-tight">
            {title}
          </h2>
          {body && (
            <p
              className={`mt-5 text-base md:text-lg leading-relaxed ${isDark ? "text-cream/80" : "text-ink/75"}`}
            >
              {body}
            </p>
          )}
        </div>
        <div className="md:col-span-5 flex flex-col gap-3">
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-base justify-center"
            data-testid="cta-book-now"
          >
            Book Now <ExternalLink size={14} />
          </a>
          <a
            href={`tel:${PHONE_TEL}`}
            className={
              isDark
                ? "btn-outline text-base justify-center"
                : "btn-ghost-dark text-base justify-center"
            }
            data-testid="cta-call-now"
          >
            <Phone size={14} /> Call {PHONE_DISPLAY}
          </a>
          {showEmail && (
            <a
              href="mailto:Centerville@westbridgehotels.com"
              className={`inline-flex items-center justify-center gap-2 text-sm mt-1 ${isDark ? "text-cream/70 hover:text-cream" : "text-forest hover:text-brass"}`}
              data-testid="cta-email"
            >
              <Mail size={13} /> Centerville@westbridgehotels.com
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
